import { useGamificationContext } from '@/shared/Gamification/GamificationContext/GamificationContext';
import BouncingStar from './BouncingStar/BouncingStar';
import { StyledGamificationScoreBoard } from './GamificationScoreBoard.styled';
import { LoadingOutlined } from '@ant-design/icons';

export default function GamificationScoreBoard({
  vertical,
  customClassName = '',
}) {
  const { state } = useGamificationContext();

  return state.isGamificationStudent ? (
    <StyledGamificationScoreBoard
      className={`score-board ${state.loading ? 'score-loading' : ''} ${
        vertical ? 'vertical' : ''
      } ${customClassName}`}
    >
      {state.loading ? (
        <div className="spin">
          <LoadingOutlined spin />
        </div>
      ) : (
        <>
          <div className="xp">
            <span>{state.xp?.toLocaleString()}</span>
            <span>XP</span>
          </div>
          <div className="stars">
            {state.stars}
            <BouncingStar stars={state.animatingStars ? 0 : state.gained} />
          </div>
        </>
      )}
    </StyledGamificationScoreBoard>
  ) : null;
}
